module.exports = __webpack_public_path__ + "img/rs.b7819b2f.png";